import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48e7769a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photovoltaic-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "光伏监控", -1))
const _hoisted_3 = { class: "chart-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "光伏发电速率", -1))
const _hoisted_5 = { class: "chart" }

import { onBeforeUnmount, onMounted } from 'vue'
import { useEnergyAnalysisStats } from '../useEnergyAnalysisStats'
import Chart from './Chart.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
    stationId: null
  },
  setup(__props: any) {

const props = __props as {
  stationId: string
}


const { genEnergy, fetchEssStationPvMonitor } = useEnergyAnalysisStats()

let timer: number | undefined

onMounted(() => {
  timer = window.setInterval(() => fetchEssStationPvMonitor(props.stationId), 5000)
})

onBeforeUnmount(() => {
  clearInterval(timer)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", null, _toDisplayString(_unref(genEnergy)) + "W/分钟", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(Chart, { value: _unref(genEnergy) }, null, 8, ["value"])
    ])
  ]))
}
}

})